module.exports = __webpack_public_path__ + "static/11month-7b4b5d26f82de2545de83111bc222a1e.png";